import { Api as api } from "../../api";
const prefix = "audit-log";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    auditLogServiceV1ListAuditLogs: build.query<
      AuditLogServiceV1ListAuditLogsApiResponse,
      AuditLogServiceV1ListAuditLogsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/audit-logs`,
        params: {
          entity_type: queryArg.entityType,
          entity_id: queryArg.entityId,
          page: queryArg.page,
          size: queryArg.size,
          action: queryArg.action,
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
          sort: queryArg.sort,
          order: queryArg.order,
        },
      }),
      // No providesTags: the app runs keepUnusedDataFor: 0.1, so cache
      // entries die 100ms after unmount and every detail visit mounts a
      // fresh subscriber — tag invalidation could never fire usefully.
    }),
    auditLogServiceV1HealthCheck: build.query<
      AuditLogServiceV1HealthCheckApiResponse,
      AuditLogServiceV1HealthCheckApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/health`,
        params: {
          source: queryArg.source,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as auditLogApi };
export type AuditLogServiceV1ListAuditLogsApiResponse =
  /** status 200 A successful response. */ AuditLogListAuditLogsResponse;
export type AuditLogServiceV1ListAuditLogsApiArg = {
  entityType: string;
  entityId: string;
  page?: number;
  size?: number;
  action?: string;
  startDate?: string;
  endDate?: string;
  sort?: string;
  order?: string;
};
export type AuditLogServiceV1HealthCheckApiResponse =
  /** status 200 A successful response. */ AuditLogHealthCheckResponse;
export type AuditLogServiceV1HealthCheckApiArg = {
  source: string;
};
export type AuditLogAuditLogItem = {
  id?: string;
  entity_type?: string;
  entity_id?: string;
  action?: string;
  field_changed?: string;
  old_value?: string;
  new_value?: string;
  changed_by?: string;
  changed_by_name?: string;
  changed_at?: string;
  service_name?: string;
  request_id?: string;
};
export type AuditLogAuditLogPaginationMetadata = {
  total?: number;
  current_page?: number;
  limit?: number;
  total_item?: number;
  total_page?: number;
  have_next_page?: boolean;
  have_previous_page?: boolean;
};
export type AuditLogListAuditLogsResponse = {
  audit_logs?: AuditLogAuditLogItem[];
  metadata?: AuditLogAuditLogPaginationMetadata;
};
export type ProtobufAny = {
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type AuditLogHealthCheckResponse = {
  status?: string;
  message?: string;
};
export const {
  useAuditLogServiceV1ListAuditLogsQuery,
  useAuditLogServiceV1HealthCheckQuery,
} = injectedRtkApi;
